// src/badiunet-system-core-lib.js

import * as Vue from "vue";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import ApexCharts from "apexcharts";
import VueApexCharts from "vue3-apexcharts";
import { VueDatePicker } from "@vuepic/vue-datepicker";


// Exponha UM namespace só (evita poluir window com 10 variáveis)
window.BADIUNET_SYSTEM_CORE_VENDOR = {
  Vue,
  axios,
  _,
  moment,
  ApexCharts,
  VueApexCharts,
  VueDatePicker

};
